// Global toast singleton — usable from any JS/JSX file without React context.
// Usage:
//   import toast from '../lib/toast';
//   toast.error('Something went wrong');
//   toast.success('Saved!');
//   toast.info('Loading…');

let _dispatch = null;

export function _registerDispatch(fn) {
  _dispatch = fn;
}

function show(message, type = 'error', duration = 5000) {
  if (_dispatch) {
    _dispatch({ message: String(message || 'An error occurred'), type, duration });
  } else {
    // Fallback before Toaster mounts (should be rare)
    if (type === 'error') console.error('[toast]', message);
    else console.log('[toast]', message);
  }
}

const toast = {
  error:   (msg, duration) => show(msg, 'error',   duration),
  success: (msg, duration) => show(msg, 'success', duration),
  info:    (msg, duration) => show(msg, 'info',    duration),
  warning: (msg, duration) => show(msg, 'warning', duration),
};

export default toast;
